import { useRouteMatch } from 'react-router-dom';
import { flatMap } from 'lodash-es';

import { tools } from '../tools-list/constants';

export const useBulkTaskRequiredCsvHeaders = () => {
  const { path } = useRouteMatch();
  const toolsList = flatMap(tools.map((tool) => tool.items));
  const requiredCSVHeaders = toolsList.find((tool) => tool.path === path)?.requiredCSVHeaders;
  return requiredCSVHeaders;
};
